export default __webpack_public_path__ + "static/2019_05-b8689ee26a557781fbbc3d7b514fe991.png";